export enum AppEnvironment {
    PRODUCTION = 'production',
    TRAINING = 'training',
    TEST = 'test',
    QA = 'qa',
    DEVELOPMENT = 'development',
}
